import React from "react";
import lexusLogo from "../assets/images/lexus-logo.png";

function LexusLogo() {
   return <img src={lexusLogo} alt="Lexus" className="lexus-logo" />;
}

export default LexusLogo;



